import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { useMemo, useState } from 'react';
import { getUserEmail } from '../Login/user_session';
export var useCollectedData = function useCollectedData() {
  var email = useMemo(function () {
    return getUserEmail();
  }, []);
  var initData = {
    travelDate: {
      dayCount: 1,
      notSure: false,
      period: [],
      selectedMonth: ""
    },
    journeyStepData: {
      choice: ""
    },
    interestsStepData: {
      selectedIds: []
    },
    budgetStepData: {
      choice: ""
    },
    emailStepData: {
      email: email,
      receiveOffers: false,
      isValid: true
    }
  };
  var _useState = useState(initData),
    _useState2 = _slicedToArray(_useState, 2),
    collectedData = _useState2[0],
    setCollectedData = _useState2[1];
  var setTravelDateData = function setTravelDateData(data) {
    setCollectedData(_objectSpread(_objectSpread({}, collectedData), {}, {
      travelDate: data
    }));
  };
  var setJourneyStepData = function setJourneyStepData(data) {
    setCollectedData(_objectSpread(_objectSpread({}, collectedData), {}, {
      journeyStepData: data
    }));
  };
  var setInterestsStepData = function setInterestsStepData(data) {
    setCollectedData(_objectSpread(_objectSpread({}, collectedData), {}, {
      interestsStepData: data
    }));
  };
  var setBudgetStepData = function setBudgetStepData(data) {
    setCollectedData(_objectSpread(_objectSpread({}, collectedData), {}, {
      budgetStepData: data
    }));
  };
  var setEmailStepData = function setEmailStepData(data) {
    setCollectedData(_objectSpread(_objectSpread({}, collectedData), {}, {
      emailStepData: data
    }));
  };
  return {
    collectedData: collectedData,
    setTravelDateData: setTravelDateData,
    setJourneyStepData: setJourneyStepData,
    setInterestsStepData: setInterestsStepData,
    setBudgetStepData: setBudgetStepData,
    setEmailStepData: setEmailStepData
  };
};